/**
 * Cross-cutting API shapes, shared so the client's types come from the server's
 * contract rather than from a hand-written mirror that drifts.
 */
export function isPending(metric) {
    return metric.value === null;
}
export function availableMetric(value) {
    return { value, availability: 'available' };
}
export function pendingMetric(availability, extra) {
    return { value: null, availability, ...extra };
}
//# sourceMappingURL=api.js.map